export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-100px.4a7b2018.jpg";